import { render, staticRenderFns } from "./ChatInviteModal.vue?vue&type=template&id=542f66ea&scoped=true&"
import script from "./ChatInviteModal.vue?vue&type=script&lang=js&"
export * from "./ChatInviteModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatInviteModal.vue?vue&type=style&index=0&id=542f66ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f66ea",
  null
  
)

export default component.exports